import React, {useMemo} from 'react';

// components
import {CardBorder, LabelContent} from '../../../shared/components';

// helpers
import {useTranslation} from 'react-i18next';

// styles
import {CardPadding, InformationContainer, Separator} from './styles';
import {Subtitle} from '../../../shared/styles';

type Props = {
  address: {
    civicNumber?: string;
    streetName?: string;
    aptNo?: string;
    city?: string;
    postalCode?: string;
    province?: string;
    country?: string;
  };
};

const Address = ({address}: Props) => {
  const {t} = useTranslation();

  const street = useMemo(() => {
    return `${address.civicNumber ?? ''} ${address.streetName ?? ''}`;
  }, [address?.civicNumber, address?.streetName]);
  return (
    <CardBorder variant="white">
      <CardPadding>
        <Subtitle bold="bold">{t('profilePage_address')}</Subtitle>
        <InformationContainer>
          <LabelContent label={t('profilePage_street')} content={street} />
          <Separator />
          <LabelContent
            label={t('profilePage_apt')}
            content={address.aptNo ?? '-'}
          />
          <Separator />
          <LabelContent
            label={t('profilePage_city')}
            content={address.city ?? '-'}
          />
          <Separator />
          <LabelContent
            label={t('profilePage_postalCode')}
            content={address.postalCode ?? '-'}
          />
          <Separator />
          <LabelContent
            label={t('profilePage_province')}
            content={address.province ?? '-'}
          />
          <Separator />
          <LabelContent
            label={t('profilePage_country')}
            content={address.country ?? '-'}
          />
        </InformationContainer>
      </CardPadding>
    </CardBorder>
  );
};

export default Address;
